import type { AnyAction } from 'redux';
import { emptyArray } from 'ui-components/default-props/empty';

import { APP_INITIALIZATION } from '../core/base-actions';
import * as Actions from './freight-settings.actions';
import type { FreightSettingsState, FreightProvider } from './freight-settings.types';

const initialState: FreightSettingsState = {
  providers: emptyArray as unknown as FreightProvider[],
  isLoadingProviders: false,
  isDisconnecting: false,
  hasError: false,
  errorMessage: '',
};

const actionHandlerMap: Record<string, (state: FreightSettingsState, action: AnyAction) => FreightSettingsState> = {
  [APP_INITIALIZATION]: (state, action) => ({
    ...state,
    providers: action?.initialData?.freightProviders ?? state.providers,
    isLoadingProviders: false,
  }),
  // Get Providers
  [Actions.FREIGHT_GET_PROVIDERS_REQUEST]: (state) => ({
    ...state,
    isLoadingProviders: true,
    hasError: false,
    errorMessage: '',
  }),
  [Actions.FREIGHT_GET_PROVIDERS_SUCCESS]: (state, action) => ({
    ...state,
    isLoadingProviders: false,
    providers: action.providers,
  }),
  [Actions.FREIGHT_GET_PROVIDERS_ERROR]: (state, action) => ({
    ...state,
    isLoadingProviders: false,
    hasError: true,
    errorMessage: action.error,
  }),

  // Disconnect Provider
  [Actions.FREIGHT_DISCONNECT_PROVIDER_REQUEST]: (state) => ({
    ...state,
    isDisconnecting: true,
    hasError: false,
    errorMessage: '',
  }),
  [Actions.FREIGHT_DISCONNECT_PROVIDER_SUCCESS]: (state) => ({
    ...state,
    isDisconnecting: false,
  }),
  [Actions.FREIGHT_DISCONNECT_PROVIDER_ERROR]: (state, action) => ({
    ...state,
    isDisconnecting: false,
    hasError: true,
    errorMessage: action.error,
  }),
};

export const reduce = (state = initialState, action: AnyAction) => {
  const actionHandler = actionHandlerMap[action.type];
  if (!actionHandler) {
    return state;
  }
  return actionHandler(state, action);
};

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { namespace } from './freight-settings.reducer.metadata';
